import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Ciudadano} from '../interfaces/utilidades/pNatural.interface';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PNaturalService {

  private apiUrl = 'https://camposdeportivos.muninuevochimbote.gob.pe/api/persona-natural'; // Cambia esta URL según tu API

  constructor(private http: HttpClient) { }

  // Obtener todos los ciudadanos
  getCiudadanos(): Observable<Ciudadano[]> {
    return this.http.get<Ciudadano[]>(this.apiUrl);
  }

  // Obtener un ciudadano por ID
  getCiudadanoById(id: number): Observable<Ciudadano> {
    return this.http.get<Ciudadano>(`${this.apiUrl}/${id}`);
  }

  // Crear un nuevo ciudadano
  create(ciudadano: Ciudadano): Observable<Ciudadano> {
    return this.http.post<Ciudadano>(this.apiUrl, ciudadano);
  }

  // Actualizar un ciudadano
  update(ciudadano: Ciudadano): Observable<Ciudadano> {
    return this.http.put<Ciudadano>(`${this.apiUrl}/${ciudadano.id_persona_natural}`, ciudadano);
  }

  // Eliminar un ciudadano
  deleteCiudadano(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }
}
